module.exports = __webpack_public_path__ + "img/white.6f7f44a5.svg";